let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2fZJm")).then(() => parcelRequire('fwp8v'));